import axios from 'axios';

export interface CalendarResponse {
    uuid: string;
    calendar_urls: {
        en: string;
        de: string;
        fr: string;
    };
}

export const getCalendarUuid = async (): Promise<CalendarResponse> => {
    const response = await axios.get<CalendarResponse>('/calendar/calendar-uuid');
    return response.data;
};
